






































import { Component, Prop, Vue } from 'vue-property-decorator';

import ArrowDownIcon from '@/components/icons/Arrow.vue';
import mobileCheck from '@/utils/mobile-check';

@Component({
  components: {
    ArrowDownIcon
  }
})
export default class CollapseConfig extends Vue {
  @Prop(String) title!: string;
  @Prop({ default: false }) opened!: boolean;
  @Prop({ default: false }) small!: boolean;
  @Prop({ default: false }) unsaved?: boolean;

  get tPrefix() {
    return 'common.components.colapsedConfig';
  }

  get height() {
    if (this.opened) return 'auto';
    if (mobileCheck() || this.small) {
      if (mobileCheck() && this.unsaved) return '98px';
      return '73px';
    }
    return '89px';
  }
}
